import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { makeStyles, Box, RED, Typography } from '@applyboard/ui-components';
var useStyles = makeStyles({
  container: {
    height: 'fit-content',
    color: RED[9],
    marginTop: '8px'
  }
});
var ErrorMessage = function ErrorMessage(props) {
  var classes = useStyles();
  var message = props.message;
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, message));
};
export default ErrorMessage;